var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
/**
 * @hidden
 */

var ListFilter = function (_super) {
  __extends(ListFilter, _super);

  function ListFilter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListFilter.prototype.render = function () {
    var _this = this;

    return React.createElement("span", {
      className: "k-list-filter"
    }, React.createElement("input", {
      ref: function ref(input) {
        return _this.input = input;
      },
      value: this.props.value || '',
      className: "k-textbox",
      onChange: this.props.onChange,
      onKeyDown: this.props.onKeyDown
    }), React.createElement("span", {
      className: "k-icon k-i-search"
    }));
  };

  return ListFilter;
}(React.Component);

export default ListFilter;